import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { FileText } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { POLICIES } from "../data/site";

export default function PolicyPage() {
  const { policyKey } = useParams();
  const policy = POLICIES[policyKey];

  if (!policy) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-32 text-center">
        <h1 className="font-display text-3xl font-bold text-white">Page not found</h1>
        <Link to="/" className="mt-6 inline-block rounded-lg bg-orange-500 hover:bg-orange-600 text-white font-semibold text-sm px-6 py-3 transition-colors duration-200">
          Back to Home
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`${policy.title} | LearnWithTAC`}</title>
        <meta name="description" content={`${policy.title} for LearnWithTAC — transparent policies for our 1-on-1 live IT security training programs.`} />
      </Helmet>
      <section className="relative py-16 sm:py-24 overflow-hidden" data-testid="policy-page">
        <div className="absolute inset-0 grid-bg" />
        <div className="relative max-w-3xl mx-auto px-4 sm:px-6">
          <Reveal className="text-center mb-14">
            <span className="inline-flex w-14 h-14 rounded-2xl bg-blue-600/20 border border-sky-500/30 items-center justify-center mb-5">
              <FileText className="w-6 h-6 text-sky-400" />
            </span>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-white">{policy.title}</h1>
            <p className="mt-3 font-mono2 text-xs uppercase tracking-[0.2em] text-slate-500">{policy.updated}</p>
          </Reveal>
          <div className="space-y-5">
            {policy.sections.map((s, i) => (
              <Reveal key={s.h} delay={i * 0.05}>
                <div className="rounded-2xl border border-sky-500/20 bg-[#0B1226] p-6 sm:p-7">
                  <h2 className="font-display text-lg font-bold text-white flex items-center gap-3">
                    <span className="font-mono2 text-xs text-orange-500">{String(i + 1).padStart(2, "0")}</span>
                    {s.h}
                  </h2>
                  <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed">{s.p}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="text-center mt-12">
            <p className="text-sm text-slate-500">
              Questions about this policy?{" "}
              <a href="mailto:info@learnwithtac.com" className="text-orange-400 hover:text-orange-300 font-semibold transition-colors duration-200">
                info@learnwithtac.com
              </a>
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
